import React, { useEffect, useState } from 'react';
import { message } from 'antd';
import axios from '../../axios/AxiosInstance';

const BASE = 'user/me/announcement-templates';

export default function AnnouncementTemplates({ field, proposal, onInsert }) {
  const [templates, setTemplates] = useState([]);
  const [open, setOpen] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [busy, setBusy] = useState(false);
  const [selected, setSelected] = useState('default');
  const [editing, setEditing] = useState(null);
  const [name, setName] = useState('');
  const [content, setContent] = useState('');
  useEffect(() => {
    if (!open || loaded) return;
    let active = true;
    axios.get(BASE, { params: { field } })
      .then(({ data }) => { if (active) { setTemplates(Array.isArray(data) ? data : []); setLoaded(true); } })
      .catch(() => { if (active) message.error('Impossible de charger vos trames.'); });
    return () => { active = false; };
  }, [open, loaded, field]);
  const chosen = templates.find(item => item._id === selected);
  const forField = data => (Array.isArray(data) ? data : []).filter(item => item.field === field);
  const startEdit = existing => { setEditing(existing?._id || 'new'); setName(existing?.name || ''); setContent(existing?.content || proposal); };
  const save = async () => {
    if (busy || !name.trim() || !content.trim()) return;
    setBusy(true);
    try {
      const body = { field, name: name.trim(), content: content.trim() };
      const { data } = editing === 'new' ? await axios.post(BASE, body) : await axios.put(`${BASE}/${editing}`, body);
      const next = forField(data);
      setTemplates(next);
      setSelected(editing === 'new' ? next[next.length - 1]?._id || 'default' : editing);
      setEditing(null);
    } catch { message.error('Impossible d’enregistrer la trame.'); }
    finally { setBusy(false); }
  };
  const remove = async () => {
    if (busy || !chosen) return;
    setBusy(true);
    try { const { data } = await axios.delete(`${BASE}/${chosen._id}`); setTemplates(forField(data)); setSelected('default'); setEditing(null); }
    catch { message.error('Impossible de supprimer la trame.'); }
    finally { setBusy(false); }
  };
  return <div>
    <button type="button" onClick={() => setOpen(value => !value)} className="text-xs font-semibold text-blue-700 hover:underline">{open ? 'Fermer les trames' : 'Choisir / personnaliser une trame'}</button>
    {open && <div className="mt-3 space-y-3 rounded-xl border border-blue-200 bg-blue-50/50 p-4">
      <div className="flex flex-wrap gap-2"><select aria-label={`Trame pour ${field}`} value={selected} onChange={event => { setSelected(event.target.value); setEditing(null); }} className="min-w-0 flex-1 rounded-lg border border-slate-200 bg-white p-2 text-sm"><option value="default">Trame proposée</option>{templates.map(item => <option key={item._id} value={item._id}>{item.name}</option>)}</select><button type="button" onClick={() => onInsert(chosen?.content || proposal)} className="rounded-lg bg-blue-700 px-3 py-2 text-sm text-white">Insérer</button></div>
      <div className="flex flex-wrap gap-3 text-xs font-semibold text-blue-700"><button type="button" onClick={() => startEdit(null)}>Nouvelle trame</button><button type="button" onClick={() => startEdit(chosen)}>Personnaliser</button>{chosen && <button type="button" disabled={busy} onClick={remove} className="text-red-700">Supprimer</button>}</div>
      {editing && <div className="space-y-3"><label className="block text-sm text-slate-700">Nom de la trame<input maxLength={100} value={name} onChange={event => setName(event.target.value)} className="mt-1 w-full rounded-lg border border-slate-200 bg-white p-2" /></label><label className="block text-sm text-slate-700">Contenu<textarea rows={5} maxLength={10000} value={content} onChange={event => setContent(event.target.value)} className="mt-1 w-full rounded-lg border border-slate-200 bg-white p-2" /></label><div className="flex justify-end gap-3"><button type="button" onClick={() => setEditing(null)} className="text-sm text-slate-600">Annuler</button><button type="button" disabled={busy || !name.trim() || !content.trim()} onClick={save} className="rounded-lg bg-blue-700 px-3 py-2 text-sm text-white disabled:opacity-50">{busy ? 'Enregistrement…' : 'Enregistrer la trame'}</button></div></div>}
      <p className="text-xs font-normal text-slate-500">Vos trames sont liées à votre compte et réutilisables dans toutes vos annonces.</p>
    </div>}
  </div>;
}
